document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var key = 'arielle_winter_favorites_v1';
  var saved = [];
  try {
    var parsed = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(parsed)) saved = parsed.filter(function (x) { return x && typeof x.url === 'string'; }).slice(0, 40);
  } catch (error) { saved = []; }
  var drawer = document.getElementById('Ar22WishlistDrawer');
  var list = document.querySelector('[data-ar22-wishlist-content]');
  var count = document.querySelector('[data-ar22-wishlist-count]');
  function store() { try { localStorage.setItem(key, JSON.stringify(saved)); } catch (error) {} }
  function refresh() {
    document.querySelectorAll('[data-ar22-wishlist]').forEach(function (button) {
      var active = saved.some(function (x) { return x.url === button.getAttribute('data-url'); });
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (button.getAttribute('data-title') || 'Artikel') + (active ? ' von Merkliste entfernen' : ' merken'));
    });
    if (count) { count.textContent = String(saved.length); count.hidden = saved.length === 0; }
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) {
      var empty = document.createElement('p');
      empty.textContent = 'Hier ist noch Platz für deine Lieblingslooks.';
      list.appendChild(empty);
      return;
    }
    saved.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'ar22-wishlist__item';
      var link = document.createElement('a');
      link.href = item.url;
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        link.appendChild(img);
      }
      var info = document.createElement('div');
      var title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.title;
      info.appendChild(title);
      var price = document.createElement('small');
      price.textContent = item.price;
      info.appendChild(price);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Entfernen';
      remove.addEventListener('click', function () {
        saved = saved.filter(function (x) { return x.url !== item.url; });
        store(); refresh();
      });
      info.appendChild(remove);
      row.appendChild(link);
      row.appendChild(info);
      list.appendChild(row);
    });
  }
  document.querySelectorAll('[data-ar22-wishlist]').forEach(function (button) {
    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url');
      if (!url) return;
      var existing = saved.findIndex(function (x) { return x.url === url; });
      if (existing >= 0) saved.splice(existing, 1);
      else saved.unshift({
        url: url,
        title: button.getAttribute('data-title') || 'ARIELLE Look',
        image: button.getAttribute('data-image') || '',
        price: button.getAttribute('data-price') || ''
      });
      saved = saved.slice(0, 40);
      store(); refresh();
    });
  });
  document.querySelectorAll('[data-ar22-wishlist-toggle]').forEach(function (button) {
    button.addEventListener('click', function () { if (drawer && !drawer.open) { refresh(); drawer.showModal(); } });
  });
  document.querySelectorAll('[data-ar22-wishlist-close]').forEach(function (button) {
    button.addEventListener('click', function () { if (drawer && drawer.open) drawer.close(); });
  });
  if (drawer) drawer.addEventListener('click', function (event) { if (event.target === drawer) drawer.close(); });
  refresh();

  var original = document.querySelector('[data-ar-add-button]');
  var form = document.querySelector('.ar-product-v10__form');
  var price = document.querySelector('[data-ar-variant-price]');
  if (original && form && price && 'IntersectionObserver' in window) {
    var sticky = document.createElement('div');
    sticky.className = 'ar22-sticky-atc';
    sticky.innerHTML = '<span class="ar22-sticky-atc__price"></span><button type="button" class="ar22-sticky-atc__button">In den Warenkorb ↗</button>';
    var stickyPrice = sticky.querySelector('.ar22-sticky-atc__price');
    var stickyButton = sticky.querySelector('button');
    document.body.appendChild(sticky);
    function sync() {
      stickyPrice.textContent = price.textContent;
      stickyButton.disabled = original.disabled;
      stickyButton.textContent = original.disabled ? 'Derzeit nicht verfügbar' : 'In den Warenkorb ↗';
      sticky.classList.toggle('is-unavailable', original.disabled);
    }
    stickyButton.addEventListener('click', function () { if (!original.disabled) original.click(); });
    var observer = new MutationObserver(sync);
    observer.observe(original, {attributes:true,childList:true,subtree:true});
    observer.observe(price, {childList:true,subtree:true});
    sync();
    var visibility = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.scrollY > 450);
    }, {threshold:0});
    visibility.observe(original);
  }
});